import * as types from './actionTypes';
import footerApi from './api';

// Utils
import isomorphicCookies from '../../../utils/isomorphicCookies';

export const toggleHomeCategories = payload => ({
  type: types.TOGGLE_HOME_CATEGORIES,
  payload,
});

export const toggleHomeCatalog = payload => ({
  type: types.TOGGLE_HOME_CATALOG,
  payload,
});

export const toggleAlcoholWarning = () => ({
  type: types.TOOGLE_ALCOHOL_WARNING,
});

export const toggleCityPopup = payload => ({
  type: types.TOGGLE_CITY_POPUP,
  payload,
});
export const toggleAuthPopup = payload => ({
  type: types.TOGGLE_AUTH_POPUP,
  payload,
});

export const setCurrentEntryStep = payload => {
  isomorphicCookies().set('current_step', payload, { expires: 1 / 24 });

  return {
    type: types.SET_CURRENT_ENTRY_STEP,
    payload,
  };
};

export const fetchFooterLinks = () => {
  return (dispatch, getState) => {
    dispatch({ type: types.FETCH_FOOTER_LINKS_REQUEST });
    const isWaitOpenings = getState().city.waitOpenings;

    return footerApi
      .getFooterLinks()
      .then(payload => {
        if (isWaitOpenings) {
          const linksToRemove = ['constructor', 'dostavka', 'nutrition'];
          payload = payload.filter(link => !linksToRemove.includes(link.link));
        }

        return dispatch({ type: types.FETCH_FOOTER_LINKS_SUCCESS, payload });
      })
      .catch(({ message }) => {
        return dispatch({ type: types.FETCH_FOOTER_LINKS_FAILURE, payload: message });
      });
  };
};
